require('./gh_element_settings.js');
require('../localizationService/localizationService.js');

/**************************************************************************************************************/
/************************************    GH-ELEMENT EDITOR LIGHT    *******************************************/
/**************************************************************************************************************/


angular.module('ghElementEditorLightModule', [
  'mainStorage',
  'oc.lazyLoad',
  'GhDialogModule',
  'config',
  'ghElementSettingsModule',
  'localizationModule'
])


.service('GhElementEditorLight', ['$q', 'fieldSettingsService', 'localizationService', 'GhDialog', function ($q, fieldSettingsService, localizationService, GhDialog) {
  var self = this;

  var ALLOWED_TABS = ['Options', 'Help'];

  function showEditDialog(fieldData, fieldModel, initCb) {
    let deferred = $q.defer();
    GhDialog.show({ settings: true,
      position: 'bottom',
      template: getTemplate(),
      locals: {
        fieldModel: fieldModel,
        fieldData: fieldData
      },
      controller: ['$scope', 'fieldModel', 'fieldData', function ($scope, fieldModel, fieldData) {
        const fieldDictionary = fieldData.getDictionary();
        const tabsDictionary = localizationService.getDictionary('gh_element_settings');
        const rawSettings = fieldData.getSettings($scope);
        const tabs = rawSettings.filter(function (setting) { return setting.type == 'general_setting';});
        const translatedSettings = localizationService.translateSettings(tabs, fieldDictionary);

        angular.extend($scope, {
          translate: (word) => localizationService.translate(word, tabsDictionary),
          tabs: self.mergeTabs(translatedSettings),
          value: fieldData.getTemplate().model.field_value,
          fieldModel: fieldModel
        });

        initCb($scope);

      }]
    }).then(function (data) {
      deferred.resolve(data);
    }, function () {
      deferred.reject();
    });

    return deferred.promise;
  }

  this.show = function (fieldModelToEdit, appId) {
    let deferred = $q.defer();
    let fieldModelCopy = angular.copy(fieldModelToEdit);

    gudhub.ghconstructor.getInstance(fieldModelToEdit.data_type).then(function (data) {

      showEditDialog(data, fieldModelCopy, function ($scope) {
        $scope.appId = appId;
        $scope.elementId = fieldModelToEdit.element_id;
        const template = localizationService.translateTemplate(data.getTemplate(), data.getDictionary());
        $scope.elementName = template.name;
        $scope.elementIcon = template.icon;
  
      }).then(function () {
        deferred.resolve(fieldModelCopy);
      }, function () {
        deferred.reject();
      });

    });

    return deferred.promise;
  };

  function getUniqueId() {
    return parseInt((new Date()).getMilliseconds() + '' + Math.floor((Math.random() * 10000) + 1));
  }

  this.mergeTabs = function (srcTab) {
    let defaultSettings = fieldSettingsService.getDefaultSettings('general_setting')
      .filter(function (setting) {
        return ALLOWED_TABS.indexOf(setting.title) !== -1;
      })
      // remove name_space setting — not applicable in light editor
      .map(function (tab) {
        tab.columns_list = tab.columns_list.map(function (column) {
          return column.filter(function (setting) {
            return setting.property !== 'name_space';
          });
        });
        return tab;
      });

    return srcTab.reduce(function (tabList, tab) {
      if (ALLOWED_TABS.indexOf(tab.title) === -1) {
        return tabList;
      }

      let findedTab = tabList.find(function (tablistTab) {
        return tablistTab.title == tab.title;
      });

      if (findedTab) {
        tab.columns_list.forEach(function (column, i) {
          findedTab.columns_list[i] = (findedTab.columns_list[i] || []).concat(column);
        });
      } else {
        tabList.push(tab);
      }

      return tabList;
    }, defaultSettings);
  };

  this.getTemplate = getTemplate;

  function getTemplate() {
    let uniqueId = getUniqueId();

    return {
      toolbar:
        `<div class="gh-element-type"><div class="gh-element-icon" gh-icon="{{elementIcon}} C0C1C3 32px normal"></div><div class="gh-element-name">{{elementName}}</div></div>
        <div class="gh-tabs-labels">
            <label ng-repeat="tab in tabs" for="tab${uniqueId}{{$index}}" ng-class="{'active': currentTab == $index}" ng-click="$parent.currentTab = $index">
               <div class="icon" gh-icon="{{tab.icon}} C0C1C3 32px normal"></div>
               <div>{{translate(tab.title)}}</div>
            </label>
         </div>`,
      content:
        `<div class="gh-tabs gh-field-settings-tabs">
          <div class="gh-tab">
            <div class="gh-tab-container" ng-if="currentTab == $index" ng-repeat="tab in tabs">
              <input type="radio" name="${uniqueId}" id="tab${uniqueId}{{$index}}" ng-checked="$index ? false : true"/>
              <div class="gh-tab-content">
                <div class="option_column" ng-repeat="column in tab.columns_list">
                  <field-setting style="height: 100%" class="flex" ng-repeat="setting in column"></field-setting>
                </div>
              </div>
            </div>
          </div>
        </div>`
    };
  }

  return this;
}]);
